export const CONNECTED: string = 'connected';
export const CONNECTING: string = 'connecting';
export const DISCONNECTED: string = 'disconnected';
export const INITIAL: string = 'initial';
export const RECONNECTING: string = 'reconnecting';
export const CLOSED: string = 'closed';

export type ProviderType = 'OpenSTF' | 'macvirt' | 'proxmox' | 'VCloudTestCenter' | 'headless' | 'no-console';

export interface ConsoleConfig {
    type: ProviderType;
    sessionId: string;
    deviceId: string;
    userId: string;
    projectId: string;
    deviceName: string;
    keepAliveTime: number;
}

export interface VCloudConsoleConfig extends ConsoleConfig {
    vmId: string;
    vmx: string;
    host: string;
    port: number;
    ticket: string;
    keyboardLayout: string;
    macKeyboardButtons: KeyboardButton[];
    winKeyboardButtons: KeyboardButton[];
    activeCapabilities: any;
}

export interface OpenSTFConsoleConfig extends ConsoleConfig {
    deviceName: string;
    openSTFDeviceSerialId: string;
    imageSocketUrl: string;
    eventSocketUrl: string;
    activeCapabilities: any;
}

export interface MacVirtConsoleConfig extends ConsoleConfig {
    wsUrl: string;
}

export interface ProxmoxConsoleConfig extends ConsoleConfig {
    wsUrl: string;
    password: string;
}

export interface KeyboardButton {
    caption: string;
    keycodes: number[];
}

export function makeVCloudConsoleConfig(config: ConsoleConfig) {
  if (config.type.toLowerCase() !== "vcloudtestcenter") {
    throw new Error(`Trying to make a VCloudConsoleConfig from a ${config.type} config`);
  }

  if (!config['isVCloudConfig']) {
    config["macKeyboardButtons"] = JSON.parse(config["macKeyboardButtons"]);
    config["winKeyboardButtons"] = JSON.parse(config["winKeyboardButtons"]);
    config["activeCapabilities"] = JSON.parse(config["activeCapabilities"]);
    config['isVCloudConfig'] = true;
  }

  return config as VCloudConsoleConfig;
}

export function makeOpenSTFConsoleConfig(config: ConsoleConfig) {
  if (config.type.toLowerCase() !== "openstf") {
    throw new Error(`Trying to make a OpenSTFConsoleConfig from a ${config.type} config`);
  }

  if (!config['isOpenSTFConfig']) {
    config["activeCapabilities"] = JSON.parse(config["activeCapabilities"]);
    config['isOpenSTFConfig'] = true;
  }

  return config as OpenSTFConsoleConfig;
}
